export default {"src":"/_next/static/media/sportsbook-op.4f1fc4eb.gif","height":360,"width":360,"blurWidth":0,"blurHeight":0};